var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
import { Textarea } from "@mui/joy";
import DOMPurify from "dompurify";
function BasicWidget(_a) {
    var _b;
    var widget = _a.widget;
    var content = ((_b = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _b === void 0 ? void 0 : _b.content) || "";
    var cleanContent = DOMPurify.sanitize(content);
    return _jsx("div", { dangerouslySetInnerHTML: { __html: cleanContent } });
}
function WidgetSettings(_a) {
    var widget = _a.widget, onChange = _a.onChange;
    return (_jsxs("div", { children: [_jsx("label", __assign({ htmlFor: "content-value", id: "content-value-label" }, { children: "Contenu" })), _jsx(Textarea, { className: "", minRows: 4, placeholder: "Enter content ...", slotProps: {
                    textarea: {
                        id: "content-value",
                        "aria-labelledby": "content-value content-value-label",
                    },
                }, value: (widget === null || widget === void 0 ? void 0 : widget.payload.content) || "", onChange: function (event) {
                    var value = event.target.value;
                    onChange && onChange(widget, __assign(__assign({}, widget.payload), { content: value }));
                } })] }));
}
widgetsDictionary.register("widget/basic", {
    name: "Basic Widget",
    display: BasicWidget,
    settings: WidgetSettings,
});
